import api from "./axios";

export const getCurrentStock =
()=>
api.get(
  "/inventory/current-stock"
);